import { useEffect, useRef } from "react"
import styles from "./index.css"

export const useExpandedSectionScroll = (
  expanded: boolean,
  contentKey?: string,
) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!expanded) return

    const frame = requestAnimationFrame(() => {
      const section = ref.current
      const container = section?.closest<HTMLElement>(
        `.${CSS.escape(styles.inputScroll)}`,
      )
      if (!section || !container || !section.getClientRects().length) return

      container.scrollTo({
        top: container.scrollHeight,
        behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches
          ? "auto"
          : "smooth",
      })
    })

    return () => cancelAnimationFrame(frame)
  }, [expanded, contentKey])

  return ref
}
